"use client";

import { useState } from "react";
import { subscribeNewsletter } from "@/services/newsletter.service";

export default function Newsletter() {
  const [form, setForm] = useState({
    nombre: "",
    apellido: "",
    email: "",
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!form.nombre || !form.apellido || !form.email) return;

    try {
      setLoading(true);
      await subscribeNewsletter(form);
      alert("¡Gracias por suscribirte!");
      setForm({ nombre: "", apellido: "", email: "" });
    } catch (error) {
      console.error(error);
      alert("Hubo un error al suscribirte. Intentá nuevamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="w-full bg-[#f2f2f2] py-16">
      {/* WRAPPER: este es el div que define el ancho de TODO (título + form) */}
      <div
        className="
          w-full
          px-4
          mx-auto
          flex
          flex-col
          items-center
          max-w-[850px]
        "
      >
        {/* TÍTULO: ocupa el 100% del wrapper */}
        <h3
          className="
    w-full
    text-center
    font-display
    uppercase
    leading-none
    mb-10
    text-[clamp(2.2rem,9vw,3.2rem)]
  "
          style={{
            color: "var(--rojo-aldo-dark)",
          }}
        >
          SUSCRÍBETE A NUESTRO
          <br />
          NEWSLETTER
        </h3>


        {/* FORM: también ocupa el 100% del wrapper */}
        <form
          onSubmit={handleSubmit}
          className="
            w-full
            bg-white/90
            rounded-[10px]
            p-4
            md:p-6
            space-y-4
          "
        >
          {/* Fila Nombre / Apellido */}
          <div className="grid gap-4 md:grid-cols-2">
            <div>
              <label
                htmlFor="nombre"
                className="block mb-1"
                style={{ fontFamily: "var(--font-family)" }}
              >
                Nombre:
              </label>
              <input
                id="nombre"
                name="nombre"
                type="text"
                required
                placeholder="Ingresa tu nombre"
                value={form.nombre}
                onChange={handleChange}
                className="
                  w-full
                  px-3
                  py-2.5
                  border
                  border-[#ccc]
                  rounded-[5px]
                  bg-[#f2f2f2]
                  text-[16px]
                  outline-none
                  focus:border-[var(--rojo-aldo-dark)]
                "
                style={{ fontFamily: "var(--font-family)" }}
              />
            </div>

            <div>
              <label
                htmlFor="apellido"
                className="block mb-1"
                style={{ fontFamily: "var(--font-family)" }}
              >
                Apellido:
              </label>
              <input
                id="apellido"
                name="apellido"
                type="text"
                required
                placeholder="Ingresa tu apellido"
                value={form.apellido}
                onChange={handleChange}
                className="
                  w-full
                  px-3
                  py-2.5
                  border
                  border-[#ccc]
                  rounded-[5px]
                  bg-[#f2f2f2]
                  text-[16px]
                  outline-none
                  focus:border-[var(--rojo-aldo-dark)]
                "
                style={{ fontFamily: "var(--font-family)" }}
              />
            </div>
          </div>

          {/* Email */}
          <div>
            <label
              htmlFor="email"
              className="block mb-1"
              style={{ fontFamily: "var(--font-family)" }}
            >
              Correo electrónico:
            </label>
            <input
              id="email"
              name="email"
              type="email"
              required
              placeholder="Ingresa tu correo electrónico"
              value={form.email}
              onChange={handleChange}
              className="
                w-full
                px-3
                py-2.5
                border
                border-[#ccc]
                rounded-[5px]
                bg-[#f2f2f2]
                text-[16px]
                outline-none
                focus:border-[var(--rojo-aldo-dark)]
              "
              style={{ fontFamily: "var(--font-family)" }}
            />
          </div>

          {/* Botón */}
          <button
            type="submit"
            disabled={loading}
            className="
              w-full
              mt-2
              py-3
              bg-[#0c0c0c]
              text-white
              rounded-[5px]
              border-none
              cursor-pointer
              font-semibold
              hover:bg-[#303030]
              transition-colors
              disabled:opacity-70
              disabled:cursor-not-allowed
            "
            style={{ fontFamily: "var(--font-family)" }}
          >
            {loading ? "Enviando..." : "Suscribirse"}
          </button>
        </form>
      </div>
    </section>
  );
}
